import { render, staticRenderFns } from "./addrsField.vue?vue&type=template&id=851d7542&scoped=true"
import script from "./addrsField.vue?vue&type=script&lang=js"
export * from "./addrsField.vue?vue&type=script&lang=js"
import style0 from "./addrsField.vue?vue&type=style&index=0&id=851d7542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851d7542",
  null
  
)

export default component.exports